import Iframe from 'react-iframe';

import { useAuthToken } from '@/hooks';
import { getDiscoveryBaseUrl } from '@/utils/discovery';
import styles from './Ambassadors.module.css';

export function Ambassadors() {
  const token = useAuthToken();
  const baseUrl = getDiscoveryBaseUrl();
  const url = `${baseUrl}?embed=ambassadors&jwt=${token}`;

  return (
    <Iframe
      url={url}
      className={styles.ambassadors}
      allow="autoplay; fullscreen; encrypted-media; picture-in-picture"
    />
  );
}
